(function () {
  "use strict";

  var CART_SECTIONS = ["cart-drawer", "cart-icon-bubble"];

  function getDrawer() {
    return document.querySelector("cart-drawer");
  }

  /* Silent DOM swap for background sync (gift add/remove): updates the drawer
     content without forcing it open if the shopper hasn't opened it. */
  function applyDrawerSectionsSilently(sections) {
    var innerSource = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");
    var newInner = innerSource.querySelector("#CartDrawer .drawer__inner") || innerSource.querySelector(".drawer__inner");
    var oldInner = document.querySelector("#CartDrawer .drawer__inner");
    if (newInner && oldInner) {
      oldInner.innerHTML = newInner.innerHTML;
      var drawer = getDrawer();
      var isEmpty = newInner.classList.contains("is-empty") || !document.querySelector("#CartDrawer .sleep-cart-item");
      if (drawer) drawer.classList.toggle("is-empty", isEmpty);
    }
    var bubbleSource = new DOMParser().parseFromString(sections["cart-icon-bubble"], "text/html");
    var newBubble = bubbleSource.querySelector(".shopify-section");
    var oldBubble = document.getElementById("cart-icon-bubble");
    if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
  }

  /* User-initiated add (upsell/cross-sell "Añadir"): reuse Dawn's own
     cart-drawer render pipeline so it opens/refreshes exactly like any other
     add-to-cart on the site (single source of truth: Shopify cart). */
  function applyDrawerSectionsAndOpen(parsedState) {
    var drawer = getDrawer();
    if (drawer && typeof drawer.renderContents === "function") {
      drawer.renderContents(parsedState);
    }
  }

  /* ============================================================
     FREE GIFT AUTO ADD/REMOVE
     Liquid (snippets/cart-drawer.liquid) computes the correct action on
     every render from the real cart totals — this only ever executes the
     ONE corrective mutation Liquid says is needed, then re-renders, which
     naturally recomputes the action (normally back to "none"). No client
     side threshold math, no polling, no state kept outside the real cart.
     ============================================================ */
  var giftSyncing = false;

  function checkGiftSync() {
    if (giftSyncing) return;
    var el = document.getElementById("SleepCartRewardSync");
    if (!el) return;
    var action = el.getAttribute("data-gift-action");
    if (action !== "add" && action !== "remove") return;

    giftSyncing = true;

    var request;
    if (action === "add") {
      var variantId = el.getAttribute("data-gift-variant-id");
      if (!variantId) {
        giftSyncing = false;
        return;
      }
      request = fetch(routes.cart_add_url + ".js", {
        ...fetchConfig("javascript"),
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: { _gift: "true" } }],
          sections: CART_SECTIONS,
          sections_url: window.location.pathname,
        }),
      });
    } else {
      var lineKey = el.getAttribute("data-gift-line-key");
      if (!lineKey) {
        giftSyncing = false;
        return;
      }
      request = fetch(routes.cart_change_url + ".js", {
        ...fetchConfig("javascript"),
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
          sections: CART_SECTIONS,
          sections_url: window.location.pathname,
        }),
      });
    }

    request
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status) {
          throw new Error(data.description || data.message);
        }
        if (data && data.sections) {
          applyDrawerSectionsSilently(data.sections);
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "sleep-cart-rewards", cartData: data });
        }
      })
      .catch(function (e) {
        console.error("Sleep cart reward sync failed:", e);
      })
      .finally(function () {
        giftSyncing = false;
      });
  }

  /* ============================================================
     UPSELL / CROSS-SELL "AÑADIR" BUTTONS
     ============================================================ */
  function initUpsellButtons(root) {
    root.querySelectorAll("[data-sleep-cart-add]:not([data-sleep-init])").forEach(function (button) {
      button.setAttribute("data-sleep-init", "true");
      button.addEventListener("click", function () {
        if (button.disabled || button.classList.contains("is-loading")) return;
        var variantId = button.getAttribute("data-variant-id");
        if (!variantId) return;

        button.classList.add("is-loading");
        var originalText = button.textContent;

        fetch(routes.cart_add_url + ".js", {
          ...fetchConfig("javascript"),
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: CART_SECTIONS,
            sections_url: window.location.pathname,
          }),
        })
          .then(function (res) { return res.json(); })
          .then(function (parsedState) {
            if (parsedState.status) {
              throw new Error(parsedState.description || parsedState.message);
            }
            applyDrawerSectionsAndOpen(parsedState);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: "sleep-cart-upsell", cartData: parsedState, productVariantId: variantId });
          })
          .catch(function (e) {
            console.error("Sleep cart upsell add failed:", e);
            button.textContent = originalText;
          })
          .finally(function () {
            button.classList.remove("is-loading");
          });
      });
    });
  }

  function init(root) {
    root = root || document;
    checkGiftSync();
    initUpsellButtons(root);
  }

  document.addEventListener("DOMContentLoaded", function () { init(document); });
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { init(document); });
  }
})();
